module.exports = __webpack_public_path__ + "static/media/crowdLogo.78564698.png";